import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ProgressContainer = styled.div`
	width: 100%;
	min-height: 6px;
	overflow: hidden;
	position: relative;
	background: #eefff1;
`;

const ProgressBarDiv = styled.div`
	width: ${(props) => `${props?.width}%` || '0%'};
	height: ${(props) => `${props?.height}px`};
	background-color: #58e713;
	text-align: center;
	line-height: 30px;
	color: white;
	transition: width 2.5s ease;
`;

const Divider = styled.div`
	position: absolute;
	height: 100%;
	border-right: 4px solid #fff;
	box-sizing: border-box;
	top: 0;
	left: ${(props) => props?.position || '0%'};
`;

export default function ProgressBar({ percentage, height = 6, spliting = 4 }) {
	const [progress, setProgress] = useState(0);

	const updateProgressBar = (newProgress) => {
		setProgress(newProgress);
	};

	const createDividers = (dividerCount) => {
		const dividers = [];
		for (let i = 1; i < dividerCount; i += 1) {
			dividers.push(<Divider key={i} position={`${(i / dividerCount) * 100}%`} />);
		}
		return dividers;
	};

	useEffect(() => {
		updateProgressBar(percentage);
	}, [percentage]);

	return (
		<ProgressContainer>
			<ProgressBarDiv height={height} width={progress} />
			{createDividers(spliting)}
		</ProgressContainer>
	);
}

ProgressBar.propTypes = {
	percentage: PropTypes.number,
	height: PropTypes.number,
	spliting: PropTypes.number,
};
